import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faUpRightAndDownLeftFromCenter } from '@fortawesome/pro-light-svg-icons';

export type ProLightUpRightAndDownLeftFromCenterProps = IconComponentProps;

export const ProLightUpRightAndDownLeftFromCenter = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightUpRightAndDownLeftFromCenterProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faUpRightAndDownLeftFromCenter}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faUpRightAndDownLeftFromCenter}
    />
  );
};

ProLightUpRightAndDownLeftFromCenter.displayName = 'ProLightUpRightAndDownLeftFromCenter';
